import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet-v1'

import { useBCKSInvitationReview } from './useBCKSInvitationReview'
import { KSReviewSheetContent } from '../blocks/KSReviewSheetContent'
import Header from 'app/BuktiKaryaPage/components/Header'

export const BCKSInvitationReview = () => {
  const {
    documentData,
    handleChangeDocument,
    handleFinalizedDocument,
    handleNextStep,
    sheetType,
    sheetOpen,
    setSheetOpen,
    setSheetType,
    handleSaveDraft,
  } = useBCKSInvitationReview()

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header title="Cek Berkas" forceNavigateBack />
      <div className="p-4">
        <Text color="subdued" className="mb-2">
          Cek kembali berkas yang diunggah dan pastikan sudah benar. Setelah
          dikumpulkan, berkas tidak dapat diganti/dihapus.
        </Text>
        <div>
          {Object.keys(documentData).map((documentName) => (
            <div className="my-8" key={documentName}>
              <Text variant="action">{documentData[documentName].title}</Text>
              <Link href={`/bcks/invitation/review/${documentName}`} passHref>
                <div className="rounded border-[#808489] border my-2 max-h-[185px] overflow-hidden">
                  <Image
                    src={documentData[documentName].thumbnailUrl}
                    alt={'image-placeholder'}
                    width={500}
                    height={500}
                  />
                </div>
              </Link>
              <Button
                color="white"
                fullWidth
                onClick={() =>
                  handleChangeDocument({
                    ...documentData[documentName],
                    name: documentName,
                  })
                }
              >
                Ganti Dokumen
              </Button>
            </div>
          ))}
        </div>

        <Sheet isOpen={sheetOpen} onClose={setSheetOpen} type="alert">
          <SheetOverlay />
          <SheetContent className="max-w-xl m-auto p-4">
            <KSReviewSheetContent
              sheetType={sheetType}
              onChangeSheetType={setSheetType}
              onChangeSheetState={setSheetOpen}
              onSubmissionClick={() => handleFinalizedDocument()}
              onContinueClick={() => handleNextStep()}
            />
          </SheetContent>
        </Sheet>

        <div className="flex flex-row items-center mt-4">
          <Button
            fullWidth
            className="mr-2"
            size="lg"
            color="white"
            onClick={() => {
              handleSaveDraft()
            }}
          >
            Simpan Draf
          </Button>

          <Button
            fullWidth
            className="ml-2"
            size="lg"
            color="blue"
            onClick={() => setSheetOpen(true)}
          >
            Kumpulkan
          </Button>
        </div>
      </div>
    </div>
  )
}
